import { _js } from '@ifixit/localize';
import DiagramTooltip from './diagramTooltip';
import copyToClipboard from 'Shared/copy_to_clipboard';
import { faClipboard, faClipboardCheck } from '@fortawesome/pro-regular-svg-icons';
import { FaIcon, FaIconProps } from '@ifixit/icons';
import { IconButton, useDisclosure } from '@chakra-ui/react';
import { motion, AnimatePresence } from 'framer-motion';

function ClipboardIcon(props: Omit<FaIconProps, 'icon'>) {
   return (
      <AnimatePresence>
         <motion.div initial={{ opacity: 1 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
            <FaIcon
               icon={faClipboard}
               fontSize="14px"
               color="gray.800"
               verticalAlign="middle"
               {...props}
            />
         </motion.div>
      </AnimatePresence>
   );
}

function CheckIcon(props: Omit<FaIconProps, 'icon'>) {
   return (
      <AnimatePresence>
         <motion.div initial={{ opacity: 1 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
            <FaIcon
               icon={faClipboardCheck}
               fontSize="14px"
               color="gray.800"
               verticalAlign="middle"
               {...props}
            />
         </motion.div>
      </AnimatePresence>
   );
}

const CopyIcon = ({ copyText }: { copyText: string }) => {
   const { isOpen, onOpen, onClose } = useDisclosure();

   const copy = () => {
      copyToClipboard(copyText);
      setTimeout(() => {
         onClose();
      }, 2000);
   };

   return (
      <DiagramTooltip
         content={_js('Copied!')}
         isOpen={isOpen}
         onOpen={onOpen}
         onClose={onClose}
         closeOnBlur={false}
         closeOnEsc={false}
         autoFocus={false}
         returnFocusOnClose={false}
      >
         <IconButton
            icon={isOpen ? <CheckIcon /> : <ClipboardIcon />}
            onClick={copy}
            aria-label="Copy Text"
         />
      </DiagramTooltip>
   );
};

export default CopyIcon;
